import React from 'react';
import { FadeIn } from './FadeIn';
export function Identification() {
  return <section className="bg-brand-beige py-20 px-6" data-id="element-328">
      <div className="max-w-3xl mx-auto text-center" data-id="element-329">
        <FadeIn data-id="element-330">
          <p className="text-xl md:text-2xl font-serif text-brand-green font-semibold mb-6 leading-relaxed" data-id="element-331">
            Si sientes que trabajas mucho y el dinero no te alcanza, no eres la
            única.
          </p>
          <p className="text-lg md:text-xl text-brand-text/80 mb-6 leading-relaxed" data-id="element-332">
            Muchas personas están descubriendo cómo generar ingresos desde casa
            usando Amazon, incluso comenzando desde cero.
          </p>
          <p className="text-lg md:text-xl text-brand-text/80 leading-relaxed" data-id="element-333">
            La diferencia es tener un sistema claro que te diga exactamente qué
            hacer, sin perder tiempo ni cometer errores.
          </p>
        </FadeIn>
      </div>
    </section>;
}